import React, { useContext, useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './Home.module.scss';
import stylesPost from '~/component/PostList/PostList.module.scss';
import PostList from '~/component/PostList';
import { FetchDataContext } from '~/component/Context/FetchDataProvider';
import ThreePicture from '~/component/ThreePicture';
import Footer from '~/component/Footer/Footer';
import useWindowWidth from '~/hooks/useWindowWidth';
import { NavLink } from 'react-router-dom';
import routes from '~/configs';
import useOnScreen from '~/hooks/useOnScreen';
import ProjectPreview from '~/Layouts/components/ProjectPreview';
import TipPreviews from '~/Layouts/components/TipPreviews';
import TiktokPreview from '~/Layouts/components/TiktokPreview';
import NewsCard from '~/Layouts/components/NewsCard';
import SlideShow from '~/Layouts/components/SlideShow/SlideShow';

const cx = classNames.bind(styles);

function Home() {
  const postCount = useWindowWidth();

  const { posts, loadPosts } = useContext(FetchDataContext);
  const [ _, setLoadPosts] = useState([]);

  const ref = useRef();
  const isOnScreen = useOnScreen(ref);

  useEffect(() => {
    loadPosts(true);
  }, [postCount]);

  useEffect(() => {
    setLoadPosts([]);

    if (isOnScreen && ref.current) {
      const children = Array.from(ref.current.children);
      children.forEach((child, index) => {
        setTimeout(() => {
          child.classList.add(stylesPost['slide-in']);
        }, index * 200); // Delay hiệu ứng giữa các phần tử
      });
    }
  }, [posts, isOnScreen]);

  return (

    <div className={cx('homepage')}>
      <div className={cx('posts')}>
        <PostList posts={posts || []} refE={ref} animation />
      </div>
      <TipPreviews />
      <NavLink to={routes.tipspage} className={cx('see-more')}>
        Xem thêm
      </NavLink>
      <ProjectPreview />
      <NewsCard/>
      <SlideShow/>
      <TiktokPreview />
      <ThreePicture />
      <Footer />
    </div>
  );
}

export default Home;
